import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { isUndefined } from 'lodash-es'
import notification from 'antd/lib/notification'
import { connect } from 'react-redux'
import './NotificationComponent.scss'

function createMarkup(message) {
  return { __html: message }
}

class NotificationComponent extends React.Component {
  componentDidMount() {
    notification.config({
      getContainer: () => this.notificationRoot,
    })
  }

  componentWillReceiveProps(nextProps) {
    const { type, message } = nextProps.notification
    if (!isUndefined(type)) {
      notification[type]({
        // eslint-disable-next-line react/no-danger
        message: <div dangerouslySetInnerHTML={createMarkup(message)} />,
        duration: 0,
      })
    }
  }

  render() {
    const { theme } = this.props

    return ReactDOM.createPortal(
      <div
        className={`notification-component antd-component ${theme}`}
        ref={(node) => {
          this.notificationRoot = node
        }}
      />,
      document.body
    )
  }
}

NotificationComponent.propTypes = {
  theme: PropTypes.oneOf(['personal', 'vmp']),
  notification: PropTypes.shape({
    type: PropTypes.oneOf(['success', 'error', 'warning']),
    message: PropTypes.string,
  }),
}

NotificationComponent.defaultProps = {
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/default-props-match-prop-types
  type: 'warning',

  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/default-props-match-prop-types
  message: '',
}

/* Component container */
const mapStateToProps = (state) => {
  return {
    notification: state.site.persistentNotification,
  }
}

const NotificationComponentContainer = connect(mapStateToProps)(
  NotificationComponent
)

export default NotificationComponentContainer
